import { Link } from "react-router-dom";

const Button = ({
  children,
  className,
  text,
  onClick,
  loading,
  large,
  round,
  to, 
  ...rest
}) => {
  const buttonContent = loading ? <div className="button-loader" /> : text ? text : children;
  const buttonStyles = {
    width: large ? "200px" : "fit-content",
    height: large && "50px",
    padding: large ? "0" : "8px 16px",
    borderRadius: round ? "50px" : "0px",
  };
  const buttonClassName = `button ${className}`;

  if (to) {
    return (
      <Link to={to} style={buttonStyles} className={buttonClassName} {...rest}>
        {buttonContent}
      </Link>
    );
  }

  return (
    <button
      style={buttonStyles}
      className={buttonClassName}
      onClick={onClick}
      {...rest}
    >
      {buttonContent}
    </button>
  );
};

export default Button;
